import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { generateId } from '../helpers/utility';
import { Modal, Button } from 'react-bootstrap';

const CenteredModal = (props) => {
  const {
    title,
    oklabel,
    cancellabel,
    children,
    onClick,
    onHide
  } = props;

  const uuid = useState(generateId());

  return (
    <Modal
      {...props}
      aria-labelledby={uuid}
      centered
      contentClassName="bg-dark"
    >
      <Modal.Header closeButton>
        <Modal.Title id={uuid}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {cancellabel}
        </Button>
        <Button variant="primary" onClick={onClick}>
          {oklabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

CenteredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  oklabel: PropTypes.string,
  cancellabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired
}

CenteredModal.defaultProps = {
  oklabel: 'Ok',
  cancellabel: 'Cancel',
};

export default CenteredModal;